import { Box, InputBase, useTheme, styled } from '@mui/material'
import { MdSearch } from 'react-icons/md'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

interface SearchBarProps {
  searchInput?: string
  placeholder?: string
  onChange?: (value: string) => void
  width?: string | number
  height?: string | number
  marginBottom?: string | number
}
export const SearchBar: React.FC<SearchBarProps> = ({
  searchInput,
  placeholder,
  onChange,
  width,
  height,
  marginBottom,
}) => {
  const theme = useTheme()
  return (
    <StyledSearchBarContainer theme={theme} marginBottom={marginBottom} minWidth={width}>
      <InputBase
        sx={{
          borderColor: getThemeColor(theme, MUIThemeColors.white),
          padding: '4px 16px',
          width: '75%',
          height: height,
        }}
        autoFocus={searchInput != '' ? true : false}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search' }}
        defaultValue={searchInput}
        onChange={event => onChange?.(event.target.value)}
      />
      <Box className="m-2">
        <MdSearch color={getThemeColor(theme, MUIThemeColors.primaryMain)} size={20} />
      </Box>
    </StyledSearchBarContainer>
  )
}

const StyledSearchBarContainer = styled(Box)<{
  theme: any
  marginBottom?: string | number
  minWidth?: string | number
}>(({ theme, marginBottom, minWidth }) => ({
  borderRadius: '4px',
  borderColor: getThemeColor(theme, MUIThemeColors.secondaryLight),
  borderWidth: '1px',
  minWidth: minWidth,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: marginBottom ? marginBottom : '0px',
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
}))
